import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/of";
import "rxjs/add/operator/catch";
import "rxjs/add/operator/map";
import "rxjs/add/operator/mergeMap";
import "rxjs/add/operator/switchMap";
import { concat as concat$ } from "rxjs/observable/concat";
import * as CreDtos from "../CRE.dtos";
import { contactUsSettingsApi } from "../services/contactUsSettings.service";

import {
    CONTACTUSSETTINGS_REQUEST,
    contactUsSettingsRequestSuccess,
    contactUsSettingsRequestFailure,
    contactUsSettingsRequest,
    CONTACTUSSETTINGS_REQUEST_UPSERT_REQUEST,
    contactUsSettingsUpsertRequestFailure,
    contactUsSettingsUpsertRequestSuccess,
    CONTACTUSSETTINGS_REQUEST_UPSERT_REQUEST_SUCCESS,
    CONTACTUSSETTINGS_REQUEST_UPSERT_REQUEST_FAILURE
} from "../actions/contactUsSettings.actions";

import {
    siteDataRequest
} from "../actions/sitedata.actions";

import {
    notificationSuccessShow,
    notificationErrorShow
} from "../actions/notification.actions";

export const contactUsSettingsRequestEpic = action$ =>
    action$
        .ofType(CONTACTUSSETTINGS_REQUEST)
        .mergeMap((action) =>
            contactUsSettingsApi
                .get()
                .mergeMap(response => {
                    return concat$(Observable.of(contactUsSettingsRequestSuccess(response.contactUsSettings)))
                })
                .catch((error: CreDtos.ForumResponse) =>
                    Observable.of(contactUsSettingsRequestFailure(error.responseStatus.message))
                )
        );

export const contactUsSettingsUpsertRequestEpic = action$ =>
    action$
        .ofType(CONTACTUSSETTINGS_REQUEST_UPSERT_REQUEST)
        .mergeMap((action) =>
            contactUsSettingsApi
                .upsert(action.contactUsSettings)
                .mergeMap(response => {
                    return concat$(Observable.of(contactUsSettingsUpsertRequestSuccess(response.contactUsSettings)))
                })
                .catch((error: CreDtos.ForumResponse) =>
                    Observable.of(contactUsSettingsUpsertRequestFailure(error.responseStatus.message))
                )
        );

export const contactUsSettingsUpsertRequestSuccessEpic = (action$, state$) =>
    action$
        .ofType(CONTACTUSSETTINGS_REQUEST_UPSERT_REQUEST_SUCCESS)
        .map((action: any) => contactUsSettingsRequest());

export const contactUsSettingsUpsertRequestSuccessNotificationEpic = (action$, state$) =>
    action$
        .ofType(CONTACTUSSETTINGS_REQUEST_UPSERT_REQUEST_SUCCESS)
        .map((action: any) => notificationSuccessShow("ContactUs settings saved"));

export const contactUsSettingsUpsertRequestSuccessSiteDataEpic = (action$, state$) =>
    action$
        .ofType(CONTACTUSSETTINGS_REQUEST_UPSERT_REQUEST_SUCCESS)
        .map((action: any) => siteDataRequest());

export const contactUsSettingsUpsertRequestErrorNotificationEpic = (action$, state$) =>
    action$
        .ofType(CONTACTUSSETTINGS_REQUEST_UPSERT_REQUEST_FAILURE)
        .map((action: any) => notificationErrorShow("Save failed: " + action.error));


// WEBPACK FOOTER //
// ./src/epics/contactUsSettings.epic.ts